import { createAsyncThunk } from "@reduxjs/toolkit";
import invoicingApi from "./api";

export const getInvoicingList = createAsyncThunk(
  "invoicing/get/loading",
  async (data) => {
    return invoicingApi.getList(data);
  }
);
